<template>
  <div class="box-info">
    <div class="info-nav-left">
      <div class="left-top">
        <i class="iconfont iconfenlei1"></i>
      </div>
      <div class="nav-item" :class="{active:type===0}" @click="toInfo('/home/znxAdmin/znxPost')" v-if="user.admin_type===1 || user.admin_type===2">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconfasong"></i>
          </div>
        </div>
        我发送的
      </div>
      <div class="nav-item" :class="{active:type===1}" @click="toInfo('/home/znxAdmin/znxGet')" v-if="user.admin_type===2 || user.admin_type===3|| user.admin_type===4">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconfasong"></i>
          </div>
        </div>
        通知
      </div>
      <div class="nav-item" :class="{active:type===2}" @click="toInfo('/home/znxAdmin/znxServe')">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconhtmal5icon31"></i>
          </div>
        </div>
        客服咨询
      </div>
      <div class="nav-item" :class="{active:type===3}" @click="toInfo('/home/znxAdmin/znxComplaint')">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont icontousu1"></i>
          </div>
        </div>
        投诉处理
      </div>
    </div>
    <div class="right">
      <router-view @setType="setType"/>
    </div>

  </div>
</template>

<script>
  export default {
    name: "znxAdmin",
    data(){
      return {
        type:''
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.$store.state.topNav = 6
    },
    methods:{
      toInfo(path){
        this.$router.push(path)
      },
      setType(type) {
        this.type = type
      }
    }
  }
</script>

<style scoped lang="scss">

</style>